exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".w5rapper{width:60%;display:block;overflow:hidden;margin:0 auto;padding:60px 50px;background:#fff;border-radius:4px}.hover-eti :hover{color:#3498db}", ""]);

// exports
